export default __webpack_public_path__ + "static/media/licensing-card.51647b4b.svg";